// extracted by mini-css-extract-plugin
module.exports = {"playBtn":"BigPlayButton_playBtn__bDnw_"};